import { render, staticRenderFns } from "./sub-history.vue?vue&type=template&id=0670b04e&scoped=true"
import script from "./sub-history.vue?vue&type=script&lang=js"
export * from "./sub-history.vue?vue&type=script&lang=js"
import style0 from "./sub-history.vue?vue&type=style&index=0&id=0670b04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670b04e",
  null
  
)

export default component.exports